import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { sendLogin } from '../../actions/userActions'
import { bindActionCreators } from 'redux'
import { withRouter } from '../../actions/withRouterHook';

function LoginContainer(props) {
    let navigate = useNavigate();
    let [username, setUsername] = useState("");
    let [password, setPassword] = useState("");

    // trigger on component mount
    useEffect(() => {
        if (props.loggedIn === true) {
            navigate("/");
        }
    });

    function changeName(event) {
        setUsername(event.target.value);
    }

    function changePassword(event) {
        setPassword(event.target.value);
    }

    function handleSubmit(event) {
        event.preventDefault();
        props.sendLogin(username, password);
    }
    
    if (!props.loggedIn) {
        return (<div className="formBox">
            <h3>Login to BI Cloud</h3>
            <form className="form" onSubmit={handleSubmit} style={{ marginLeft: "10px" }}>
                <label className="label">
                    Username:  &nbsp;
                </label>
                <input type="text" name="name" onChange={changeName} value={username} />
                <br /><br />
                <label className="label">
                    Password:  &nbsp;
                </label>
                <input type="password" name="name"  onChange={changePassword} value={password} />
                <br /><br />
                <input className="submitButton" type="submit" value="Submit" />
            </form>
        </div>)
    } else {
        navigate("/");
    }
}

function mapStateToProps(state) {
    return {
        loggedIn: state.users.loggedIn,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ sendLogin }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginContainer))